import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
 
import { IonicModule } from '@ionic/angular';


import {CustomModule} from "../customs/custom.module";
import {PharmacyMapRoutingModule} from "./pharmacy-map-routing.module";
import {PharmacyMapComponent} from "./pharmacy-map.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,   
    PharmacyMapRoutingModule,
      CustomModule
  ],
  declarations: [PharmacyMapComponent]
})
export class PharmacyMapModule {}
